import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { noop } from '@constants/general';
import { FILING_RESET } from '@store/filing/filing.const';

import aggregatesReducer from './aggregates/aggregates.reducer';

const initialState = {};

const combinedReducers = combineReducers({
  aggregates: aggregatesReducer,
});

const filingRootReducer = createReducer(initialState, builder => {
  builder.addCase(FILING_RESET, () => initialState).addDefaultCase(noop);
});

export default (state = initialState, action) => {
  const newState = filingRootReducer(state, action);
  return combinedReducers(newState, action);
};
